/**
 * usePretreatMutation - Pretreat scan mutation
 *
 * Follows production-orders pattern with:
 * - Proper cache invalidation using tRPC utils
 * - Clear error handling with toast notifications
 * - isPending for loading state (not isLoading)
 */
import { trpc } from '@/lib/trpc';
import { toast } from '@/hooks/use-toast';

export function usePretreatMutation(onSuccess?: () => void) {
  const utils = trpc.useUtils();

  const scanIntoPretreat = trpc.pretreat.scanIntoPretreat.useMutation({
    onSuccess: (data) => {
      // Invalidate stats to refresh counts
      utils.pretreat.getStats.invalidate();

      // Show success toast only for successful scans
      if (data.status === 'success' && data.garment) {
        toast({
          title: 'Pretreat Scan Recorded',
          description: `${data.garment.productName} - ${data.garment.orderName}`,
        });
      }

      onSuccess?.();
    },
    onError: (error) => {
      toast({
        title: 'Scan Error',
        description: error.message || 'Failed to scan garment',
        variant: 'destructive',
      });
    },
  });

  return {
    scanIntoPretreat,
    isScanning: scanIntoPretreat.isPending, // Use isPending, NOT isLoading
  };
}
